<template>
    <b-container fluid class="headerPushDown">
         
        <b-container v-if="validOrdersFound && !isPaymentInProgress" class="ml-auto mr-auto pl-2 pr-2">
            <p class="text-muted breadCrumbs text-uppercase">
             <router-link to="/app/cart"> 1.Warenkorb</router-link>  |  <router-link to="/app/checkout">2.Details</router-link>  |
                    <span class="font-weight-bold text-dark">3.Überprüfen</span> 
                </p>   
            <b-row>
                <b-col cols="12" md="6" v-if="true ||this.$store.getters.getCachedOrder.hasAnyShipping">
                    <h4 class="text-uppercase">Rechnungsadresse</h4>                    
                    <p class="mt-3 mb-1 font-weight-bold">{{  this.$store.getters.getCachedOrder.customerData.billingAddress.firstname}}
                                    {{  this.$store.getters.getCachedOrder.customerData.billingAddress.lastname}}
                    </p>
                    <p class="mt-0 mb-0">{{  this.$store.getters.getCachedOrder.customerData.billingAddress.street}}</p>
                    <p class="mt-0 mb-0">{{  this.$store.getters.getCachedOrder.customerData.billingAddress.zip}}, {{  this.$store.getters.getCachedOrder.customerData.billingAddress.city}}</p>
                    <p class="mt-0 mb-0">{{  this.$store.getters.getCachedOrder.customerData.billingAddress.country}}</p>
                </b-col>

                <b-col cols="12" md="6" v-if="this.$store.getters.getCachedOrder.enableShippingAddress && this.$store.getters.getCachedOrder.enableShippingAddress !='false'" class="mt-3 mt-md-0">
                    <h4 class="text-uppercase">Lieferadresse</h4>
                    <p class="mt-3 mb-1 font-weight-bold">{{  this.$store.getters.getCachedOrder.customerData.shippingAddress.firstname}}
                                    {{  this.$store.getters.getCachedOrder.customerData.shippingAddress.lastname}}
                    </p>
                    <p class="mt-0 mb-0">{{  this.$store.getters.getCachedOrder.customerData.shippingAddress.street}}</p>
                    <p class="mt-0 mb-0">{{  this.$store.getters.getCachedOrder.customerData.shippingAddress.zip}}, {{  this.$store.getters.getCachedOrder.customerData.shippingAddress.city}}</p>
                    <p class="mt-0 mb-0">{{  this.$store.getters.getCachedOrder.customerData.shippingAddress.country}}</p>
                </b-col>
            </b-row>

            <b-row>
                <b-col class="mt-4">                    
                    <p class="mt-0 mb-0 p-0">
                        <span class="text-uppercase">E-Mail:</span> 
                        {{this.$store.getters.getCachedOrder.emailAddress}}
                        <span v-if="this.$store.getters.getCachedOrder.newsletter" > (Newsletter angefordert)</span>
                        </p>

                    <p class="mt-2 mb-0 p-0"><span class="text-uppercase">Telefon:</span> {{this.$store.getters.getCachedOrder.customerData.phone}}</p>
                </b-col>
                
            </b-row>
           
            <b-row v-if="!showMobileTable" class="border-bottom">
                <b-col sm="12">
                    <h4 class="mt-4 text-uppercase">Warenkorb</h4>
                    <b-table class="text-dark "
                        :bordered="false"
                        :borderless="true"
                        :outlined="false" 
                        :hover="false" responsive 
                        :items="this.$store.getters.getBasket.items" 
                        :fields="tableHeaderFields">
                     <!-- A virtual index column -->
                    <template slot="index" slot-scope="data">
                        {{ data.index + 1 }}
                    </template>

                    <template slot="image" slot-scope="data">                       
                      <b-img v-if="data.item.image != undefined" :src="$store.getters.getWebServerBaseUrl + data.item.image"
                       width="100px" />
                    </template>

                    <template slot="title" slot-scope="data">                       
                        <div class="font-weight-bold" v-html="data.item.title"></div> 
                        <div  v-html="data.item.description"></div> 
                    </template>

                    <template slot="price" slot-scope="data">                       
                      € {{ data.item.price.toFixed(2) }}
                    </template>
                    
                    <template slot="count" slot-scope="data">
                        <div class="product-amount-selection flex-center">
                            {{data.item.count}}
                        </div> 
                    </template>

                    <template slot="total" slot-scope="data">                       
                        € {{ data.item.total.toFixed(2) }}
                    </template>                    
                </b-table>
                </b-col>
            </b-row>  

            <b-row v-if="showMobileTable">
                <b-col cols="12">
                    <h4 class="mt-3 mb-3 text-uppercase">Warenkorb</h4>
                    <!-- TABLEHEADING -->
                    <b-row class=" border-bottom">
                        <b-col cols="6" class="text-uppercase text-dark font-weight-bold text-center">Produkt</b-col> 
                        <b-col cols="6" class="text-uppercase text-dark font-weight-bold text-center">Preis</b-col>
                    </b-row>
                    <b-row v-for="(item,index) in $store.getters.getBasket.items" :key="index" class="mb-2 pb-2 mt-2 border-bottom">
                        <b-col class="p-0 pr-1"  cols="6">
                            <div class="text-gray font-weight-bold" v-html="item.title"></div> 
                            <div class="ml-1" v-html="item.description"></div>
                        </b-col>
                        <b-col cols="6" class="p-0 pl-1"> 
                            <div class="product-amount-selection mt-0 p-0 ml-0">
                                  Anzahl:&nbsp;                                
                                    <div class="text-center ">
                                        {{item.count }}
                                    </div>
                                
                            </div>                       
                                                        
                            <div>Preis:&nbsp;&nbsp;&nbsp;&nbsp; € <span class="">{{ item.price.toFixed(2) }}</span></div>

                            <div>Gesamt: € <span class="font-weight-bold">{{ item.total.toFixed(2) }}</span>   </div>
                        </b-col>
                    </b-row>
                </b-col> 
            </b-row>

  
            <b-row class="text-dark p-0 mt-2 border-bottom">
                <b-col cols="2" class="p-0">
                    <label class="ml-3">Zwischensumme</label>
                </b-col>
                <b-col cols="10" class="text-right">
                    <label class="mr-3">€ {{$store.getters.getBasket.subTotal.toFixed(2)}}</label>
                </b-col>
            </b-row>
            <b-row  class="text-dark mt-2 border-bottom" v-if="$store.getters.getBasket.shipping > 0">
                <b-col cols="2" class="p-0" >
                    <label class="ml-3">Versandkosten</label>
                </b-col>
                <b-col cols="10" class="text-right">
                    <label class="mr-3">€ {{$store.getters.getBasket.shipping.toFixed(2)}}</label>
                </b-col>
            </b-row>
            <b-row  class="text-dark mt-2 border-bottom" v-if="$store.getters.getBasket.discount > 0">
                <b-col cols="2" class="p-0">
                    <label class="ml-3 text-danger">Rabatt</label>
                </b-col>
                <b-col cols="10" class="text-right" >
                    <label class="mr-3 text-danger">€ {{$store.getters.getBasket.discount.toFixed(2)}}</label>
                </b-col>
            </b-row>
           
            <b-row  class="text-dark mt-2">
                <b-col cols="2" class="p-0">
                    <label class="ml-3 font-weight-bold">Summe</label>
                </b-col>
                <b-col cols="10" class="text-right font-weight-bold">
                    <label class="mr-3">€{{$store.getters.getBasket.total.toFixed(2)}}</label>
                </b-col>
            </b-row>

            <b-row v-if="$store.getters.getBasket.taxes.length == 0" class="mt-2">
                <div v-if="$store.getters.getBasket.tax == 0">
                <b-col cols="12" class="p-0">
                    <label class="ml-3">MwSt. für Wertgutscheine wird bei Erbringung der Leistung ausgewiesen</label>
                </b-col>
                </div>
                <div v-if="$store.getters.getBasket.tax != 0">
                <b-col cols="4">
                    <label class="ml-3">davon&nbsp;MwSt.</label>
                </b-col>
                <b-col  cols="8" class="text-right">
                    <label class="mr-3">€ {{ $store.getters.getBasket.tax.toFixed(2)}}</label>
                </b-col>  
                </div> 
            </b-row>

            <b-row v-if="$store.getters.getBasket.taxes.length > 0" class="p-0 m-0 mt-2">
                <b-col cols="12" class="p-0">
                    <b-row v-for="(tax, index) in $store.getters.getBasket.taxes" :key="index">

                        <b-col cols="4" class="p-0">
                            <label class="ml-3 ">MwSt. {{tax.percentage}} %</label>
                        </b-col>
                        <b-col  cols="8" class="text-right">
                            <label class="mr-3">€ {{tax.total.toFixed(2)}}</label>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class=" border-top">
                <b-col cols="0" md="2" v-if="!this.$store.getters.getBasket.shipping !=0"></b-col>
                <b-col cols="12" md="4">
                    <b-form-checkbox class="mt-2"
                        id="TermsAndConditions"
                        v-model="isTermsAndConditionsAccepted"
                        value="true"
                        unchecked-value="false">                        
                            Ich akzeptiere die
                            <a href="/app/privacy" target="_blank" class="checkoutAgbLink" >Datenschutzvereinbarung</a>
                    </b-form-checkbox>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-checkbox class="mt-2"
                        id="Privacy"
                        v-model="isPrivacyAccepted"
                        value="true"
                        unchecked-value="false">
                        Ich akzeptiere die <a href="/app/conditions" target="_blank" class="checkoutAgbLink" >AGB</a>
                        und habe das <a href="/app/revocation" target="_blank" class="checkoutAgbLink" >Widerrufsrecht</a>
                        zur Kenntnis genommen.
                     
                    </b-form-checkbox>  
                </b-col> 
                <b-col cols="12" md="4" v-if="this.$store.getters.getBasket.shipping != 0">

                    <b-form-checkbox class="mt-2"
                        id="newsletter"
                        v-model="isShareInfoTransportAccepted" 
                        value="true"
                        unchecked-value="false">
                        Ich willige der Datenweitergabe an Transportunternehmen ein.  
                    </b-form-checkbox>                   
                </b-col>
            </b-row>
            <b-row class="mt-4 mt-md-0">
                <b-col sm="12" md="6" v-if="$store.getters.getBasket.total.toFixed > 0" class="mb-3 ml-1 ml-md-5 mt-md-3 text-center">
                    <h4 class="text-uppercase">Zahlungsart</h4>
                    <b-img width="80px" :src="'/imageFile/' + getPaymentMethod.image" v-if="getPaymentMethod.image != ''"></b-img>
                    <div v-else style="width: 80px;" class="d-inline-block"></div>
                    {{  getPaymentMethod.title  }}
                </b-col>
                
                <b-col sm="12" md="5" class="p-0 m-0 mt-md-3 text-center"> 
                    <!-- recaptcha disabled -->
                    <vue-recaptcha v-if="false || siteKey" class="ml-0 ml-md-3 p-0 float-right" :sitekey="siteKey" ref="recaptcha" @expired="onCaptchaExpired" @verify="onCaptchaVerified"></vue-recaptcha>
 
                    <b-button v-if="!getCheckBoxValidation || isPaymentInProgress" class="mt-2 text-uppercase  float-right" size="md" variant="light" style="" disabled>
                       Zahlungspflichtig Bestellen
                    </b-button> 

                    <b-button v-if="getCheckBoxValidation && !isPaymentInProgress" @click="sendOrder" class="mt-2 text-uppercase float-right " variant="light" size="md" style="">
                       Zahlungspflichtig Bestellen
                    </b-button>  
                   
                </b-col>
            </b-row>  
                <div v-if="paymentError!=''" class="float-right mr-md-3">
                    <div v-html="paymentError"></div>
                </div>
            
        </b-container>

        <b-container v-if="!validOrdersFound"  style="margin-top: 100px;">
            <h4>Fehler bei der Weiterverarbeitung</h4>  
        </b-container>

        <b-container v-if="validOrdersFound && isPaymentInProgress" class="p-0">
            <iframe :src="paymentHtml" height="500px" width="100%" id="ZZ" frameborder="0" style="border:none;"></iframe> 
        </b-container>


  </b-container>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'; 

export default {
    name: 'ShopCartView',
    components: {
         VueRecaptcha
    },
    data() {
        return {
            panelData: [],
            redeemCode: '',
            redeemCodeError: undefined,
            siteKey: undefined,
            reCaptchaOK: false,
            reCaptchaToken: undefined,
            tableHeaderFields:{
                itemImage: {
                    key: 'index',
                    label: '',
                    sortable: false,
                },
                image: {
                    key: 'image',
                    label: '', // FIXME: multilanguage!!!
                    sortable: false,
                },
                product: {
                    key: 'title',
                    label: 'PRODUKT', // FIXME: multilanguage!!!
                    sortable: false,
                },
                price: {
                    key: 'price',
                    label: 'PREIS', // FIXME: multilanguage!!!
                    sortable: false,
                     class: 'text-center'
                },
                count: {
                    key: 'count',
                    label: 'ANZAHL', // FIXME: multilanguage!!!
                    sortable: false,
                    class: 'text-center'
                },
                totalPrice: {
                    key: 'total',
                    label: 'GESAMT', // FIXME: multilanguage!!!
                    sortable: false,
                    class: 'text-center'
                },                
            },
            paymentHtml: undefined,
            paymentMethods: undefined,
            isTermsAndConditionsAccepted: false,
            isPrivacyAccepted: false,
            isShareInfoTransportAccepted: false,
            checkboxErrors: undefined,
            showMobileTable: false,
            paymentError: '',
            isPaymentInProgress: false,
        
        };
    },
    computed: {
        getCheckBoxValidation(){
            if((this.isPrivacyAccepted == true || this.isPrivacyAccepted == 'true' ) &&
               (this.$store.getters.getBasket.shipping != 0 && (this.isShareInfoTransportAccepted == true || this.isShareInfoTransportAccepted == 'true' )) &&             
               (this.isTermsAndConditionsAccepted == true || this.isTermsAndConditionsAccepted == 'true' )){

                return true;
            }else if(   (this.isPrivacyAccepted == true || this.isPrivacyAccepted == 'true' ) &&
                        (this.isTermsAndConditionsAccepted == true || this.isTermsAndConditionsAccepted == 'true' ) &&
                        (this.$store.getters.getBasket.shipping == 0 || this.$store.getters.getBasket.shipping == '0' )){
                   
                return true;
            }else{
                return false;
            }
        },   
        getSelectedLanguage() {
            return this.$store.getters.getLanguage;
        },
        getLanguageItem: function() {
            return this.$store.getters.getLanguageStrings;
        },
        getCurrentImage(){
           return this.$store.getters.getWebServerBaseUrl ;
        },
        validOrdersFound(){
            if (this.$store.getters.getCachedOrder) {
               //console.log('enableShippingAddress was: ' , this.$store.getters.getCachedOrder.enableShippingAddress );
               
                return true;
            }else{
                //console.log('No Cached Info found, redirecting back ...');

                this.$router.go(-1);
                return false;
            }
        },
        getPaymentMethod(){
           console.log('Cached paymentMethod',  this.$store.getters.getCachedOrder.paymentMethod);

           let method = this.paymentMethods.find(e => {
               if(e.id == this.$store.getters.getCachedOrder.paymentMethod){
                   return e;
               }else{
                   console.log('no method found');                   
               }
                 
            });
          // console.log('method: ', method);
           
           return method;
           
        }
    },
    methods: {
        showModal() {
            this.$refs.PaymentModal.show();
        },
        hideModal() {
            this.$refs.PaymentModal.hide();
        },
        async loadShoppingBasketFromServer() {
            let config = {
                header: this.$store.getters.getRestHeader,
                params: {
                localeId: this.getSelectedLanguage.ident /* Language: de, en */
                }
            };

            await this.$http
                .get(this.$store.getters.getRestServerBaseUrl + "/basket", config)
                .then(response => {
               // console.log("GET basket: " + response.status);
                //console.log(response.data);

                // save to store
                this.$store.dispatch('saveBasket', response.data);

               // console.log('stored Basket: ', this.$store.getters.getBasket);        
                })
                .catch(err => {
                console.log("GET basket ERROR: ", err);
                // reset basket? FIXME

                });
        },
        async postUpdateBasket(params) {      
    
            let config = this.$store.getters.getRestHeaderConfig;
            config.params = undefined; // make sure they are empty           

            //console.log('POST updateBasket:', params, config);

            await this.$http
                .post(this.$store.getters.getRestServerBaseUrl + "/updateBasket", params , config)
                .then(response => {
                //console.log("POST updateBasket response: "  + response.status, response.data); 

                // save to store
                this.$store.dispatch('saveBasket', response.data);
                })
                .catch(err => {
                console.log("POST updateBasket ERROR: ", err);
                });
        },        
        openCheckout(){
            // check basket
            this.$router.push('/app/checkout');
        },
        onCaptchaVerified(recaptchaToken){
            //console.log('recaptchaToken: ', recaptchaToken);
            this.reCaptchaOK = true;
            this.reCaptchaToken = recaptchaToken;
        },
        onCaptchaExpired() {
            this.$refs.recaptcha.reset();
            this.reCaptchaOK = false;
            this.reCaptchaToken = undefined;
        },
        async loadRecaptchaKeyFromServer() {
            let config = this.$store.getters.getRestHeaderConfig;
            config.params = null;

            await this.$http
                .get(this.$store.getters.getRestServerBaseUrl + "/recaptchaKey", config)
                .then(response => {
                    // console.log("GET recaptchaKey: " + response.status);
                    // console.log(response.data);
                    this.siteKey = response.data;

                   // console.log('stored recaptchaKey: ', this.$store.getters.getBasket);        
                })
                .catch(err => {
                console.log("GET recaptchaKey ERROR: ", err);

                });
        },
        async postCheckoutToServer(params) {      
    
            let config = this.$store.getters.getRestHeaderConfig;
            config.params = undefined; // make sure they are empty           

           // console.log('POST checkout:', params, config);

         await this.$http
            .post(this.$store.getters.getRestServerBaseUrl + "/checkout", params , config)
            .then(response => {
                //console.log("POST checkout response: "  + response.status/* , response.data */);          
                
                this.isPaymentInProgress = true;

                // redirect is only a url
                if (response.data.redirect) {
                    // take care of sum=0 orders (no payment)
                    console.log('redirect:', response.data.redirect);
                    if(response.data.redirect.toLowerCase().indexOf("paypal") >= 0){
                        console.log("success");
                        window.location.href = response.data.redirect;
                    }else{
                        this.paymentHtml = response.data.redirect; // <- better 
                    }

                }else{

                    // IE does not support 'data:' uri's for navigation 
                    // https://stackoverflow.com/questions/7405345/data-uri-scheme-and-internet-explorer-9-errors


                    // this.paymentHtml = response.data.embed;
                    //<script> cant be attached directly....so we replace "test" with script afterwards

                    let Resizer = '<test type="text/javascript" src="/js/iframeResizer.contentWindow.min.js" defer></test>';
                    Resizer = Resizer.replace('<test','<script');
                    Resizer = Resizer.replace('/test','/script');

                    let html = response.data.embed + Resizer;
                    //console.log('HTML: ',html);


                    let blob = new Blob([html],{type: 'text/html'});
   
                    this.paymentHtml = URL.createObjectURL(blob);

                    //this.showModal(); 
                } 
                               
                try {                            
                    /* init IframeResizer script  */
                    window.iFrameResize();
                } catch (error) {
                    console.log('IFrame resizer ERROR: ', error);
                    
                }

                window.scroll({
                    top: 0, 
                    left: 0, 
                    behavior: 'smooth' 
                }); 

                })
                .catch(err => {
                    console.log("POST checkout ERROR: ", err);
                    if(err.response.status != 500){
                         this.paymentError = '<span class="text-danger text-center">'+ err.response.data.errorText + '</span>';
                    }else{
                        this.paymentError =  '<span class="text-danger text-center">Es ist ein Fehler aufgetreten. </span>';
                    }
                    //this.isPaymentInProgress = false;
                });
        },
        sendOrder(){
           // console.log('Sending Order: ', this.$store.getters.getCachedOrder);
            if(!this.getCheckBoxValidation){           
                // Errormessage
               // console.log('Checkbox validation failed');
                
                return;
            }



            let params = this.$store.getters.getCachedOrder; 
            console.log('Cached Params:', params);
            
           // params.reCaptcha = this.reCaptchaToken,
           
            this.postCheckoutToServer(params)
        },
        async loadPaymentMethodsFromServer(){
            let config = this.$store.getters.getRestHeaderConfig;
            config.params = {};

            await this.$http
                .get(this.$store.getters.getRestServerBaseUrl + "/paymentMethods", config)
                .then(response => {
                    console.log("GET /paymentMethods: " + response.status);
                    console.log('PAYMENT Data:', response.data);
                    this.paymentMethods = response.data;

                })
                .catch(err => {
                    console.log("GET paymentMethods", err.response);
                });
        },
        handleResize() {
           // this.window.width = window.innerWidth;
           // this.window.height = window.innerHeight;

           // console.log('width', window.innerWidth);
            if(window.innerWidth < 768){
                this.showMobileTable=true;
            }else{
                this.showMobileTable=false;
            }
            
        }
    },
    mounted(){
        //this.loadRecaptchaKeyFromServer();
        this.loadPaymentMethodsFromServer();
        // console.log('Loading Cached OrderDetails: ', this.$store.getters.getCachedOrder);
        window.scroll({
        top: 0, 
        left: 0, 
        behavior: 'smooth' 
        }); 
    },
    created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },
}
</script>
